"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _ListChoice = _interopRequireDefault(require("../../ListChoice"));
var _CheckCircle = _interopRequireDefault(require("../../icons/CheckCircle"));
const InputSelectOption = /*#__PURE__*/React.forwardRef(({
  active,
  id,
  onClick,
  isSelected,
  title,
  description,
  prefix
}, ref) => {
  return /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(active && "[&_.orbit-list-choice]:bg-cloud-light")
  }, /*#__PURE__*/React.createElement(_ListChoice.default, {
    id: id,
    onClick: onClick,
    ref: ref,
    tabIndex: -1,
    selected: isSelected,
    action: isSelected && /*#__PURE__*/React.createElement(_CheckCircle.default, {
      ariaHidden: true,
      color: "info"
    }),
    role: "option",
    title: title,
    description: description,
    icon: prefix
  }));
});
var _default = exports.default = InputSelectOption;